import * as API_CONSTANT from '../constants'

export const getTripRecordByTimeFrameSync = (vid, startTime, endTime) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/trip/record/timeframe/get/sync`, {
      method: 'POST',
      headers: API_CONSTANT.headers,
      body: JSON.stringify({
        vid,
        startTime,
        endTime
      })
    })
      .then(res => res.json())
  )

export const getVideoPlaybackByTimeFrameSync = (vid, startTime, endTime, sessionId, source = 'server') => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/mdvr/videoplayback/timeframe/sync`, {
      method: 'POST',
      headers: API_CONSTANT.headers,
      body: JSON.stringify({
        vid,
        startTime,
        endTime,
        sessionId,
        source
      })
    })
      .then(res => res.json())
  )